import { fetchGet } from "../util/apiUtil";

export const loadClubs = () => fetchGet("Club/GetAll");
